/* eslint-disable */
import { Empty } from 'antd';
import React, { FC, useLayoutEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useMediaQuery } from 'react-responsive';
import { Redirect, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ApplicationCommonErrors from '~/components/views/ApplicationCommonErrors';
import features from '~/constants/features';
import { useGetApplication, useSelectStep } from '~/controllers/wizard';
import WizardNavigation from '~/layouts/WizardNavigation';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import paths from '~/pages/paths';
import { getStagePayload } from '~/utils/getStagePayload';
import { Stage } from '~/types/Application';

import address from './address';
import companyInformation from './companyInformation';
import companyQuestionnaire from './companyQuestionnaire';
import riskQuestionnaire from './riskQuestionnaire';
import managers from './managers';
import bankAccount from './bankAccount';
import shareholders from './shareholders';
import reviewAndSubmit from './reviewAndSubmit';
import ReviewAndSubmitRightContent from './reviewAndSubmit/components/ReviewAndSubmitRightContent';
import ApplicationNavigation from '~/layouts/uae/ApplicationNavigation';
import ApplicationSummary from '~/components/ApplicationSummary';
import DataValidation from '~/pages/ksa/dataValidation/DataValidation';
import { useHistory } from 'react-router';

// import theme from '~/constants/theme';

const views: Record<string, React.ComponentType> = {
  businessDetails: companyInformation,
  address: address,
  companyQuestionnaire: companyQuestionnaire,
  riskQuestionnaire: riskQuestionnaire,
  businessOwners: managers,
  bankDetails: bankAccount,
  shareholders: shareholders,
  reviewAndConfirm: reviewAndSubmit,
};

const Application: FC<void> = () => {
  const location = useLocation();
  const history = useHistory();
  const selectStep = useSelectStep();
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const applicationSteps = stagePayload?.steps.find((item) => item.key === 'application')?.steps;

  const isReviewAndSubmit = location.pathname.includes('reviewAndSubmit');

  return (
    <WizardContent
      left={
        <LeftLayout>
          <ApplicationNavigation />
        </LeftLayout>
      }
      content={
        <>
          {paths.ksa.application === location.pathname && (
            <Redirect
              exact
              from={paths.ksa.application}
              to={`${paths.ksa.application}/businessDetails`}
            />
          )}
          {applicationSteps?.map((item) => {
            if (item.state === 'HIDDEN') return null;
            return (
              <Route
                key={item.key}
                path={`${paths.ksa.application}/${item.pathKey}` as any as string}
                component={views[item.pathKey] || Empty}
              />
            );
          })}
        </>
      }
      right={
        <RightContainer>
          <ApplicationSummary />
        </RightContainer>
      }
    />
  );
};

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;

  .upperContainer {
    height: 100%;
  }

  .WizardContinueButton,
  .NoteText {
    margin-top: 24px;
  }
`;

export default Application;
